import { render, staticRenderFns } from "./EllyEbby.vue?vue&type=template&id=42341152&"
import script from "./EllyEbby.vue?vue&type=script&lang=js&"
export * from "./EllyEbby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports